var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"etiqueta-pequena",style:({ color: _vm.cor })},[_c('span',{staticClass:"etiqueta-pequena__fundo"}),_c('span',{staticClass:"etiqueta-pequena__texto"},[_vm._v(_vm._s(_vm.texto))])])}
var staticRenderFns = []

export { render, staticRenderFns }